import React, { Component } from "react";
import SelectComponent from "../Select";
import { Step3Langague } from "../../data/locale";
import InputMask from "react-input-mask";

export default class NameThComponent extends Component {

    _getLang(field) {
        const lang = this.props.langague === 2 ? "en" : "th";
        return Step3Langague[field][lang];
    }
    
    render() {
        const { keyIndex, titles,
          sInitNameTH, sFirstNameTH, sLastNameTH, 
          options, onChange ,
          labelVisa,
          labelLang
        } = this.props;
        const { initKey = 'sInitNameTH', firstNameKey = 'sFirstNameTH', lastNameKey = 'sLastNameTH' } = options || {};
        const key = keyIndex;
        return (
        <div className="form-group">
          <label>{labelVisa === 1 || labelLang === 2 ? "Name/Surname(Thai)" : "ชื่อ/นามสกุล(ภาษาไทย)"}</label>
          <SelectComponent
            placeholder={labelVisa === 1 || labelLang === 2 ? "Prefix" : "คำนำหน้าชื่อ"}
            options={titles}
            selected={sInitNameTH}
            onChange={selected =>
              onChange({ key, name: initKey, value: selected })
            }
          />
          <InputMask
            mask="********************"
            maskChar=''
            formatChars={{
              '*': '[\u0E00-\u0E7Fก-ฮ]',
            }}
            permanents={[2, 5]}
            type="text"
            value={sFirstNameTH}
            onChange={e =>
              onChange({ key, name: e.target.name, value: e.target.value })
            }
          >
            {inputProps => (
              <input
                id={`sFirstNameTH_${key}`}
                {...inputProps}
                className="form-control mt-2"
                placeholder={labelVisa === 1 || labelLang === 2 ? "FIRST NAME" : "ชื่อ"}
                name={firstNameKey}
              />
            )}
          </InputMask>
          <InputMask
            mask="********************"
            maskChar=''
            formatChars={{
              '*': '[\u0E00-\u0E7Fก-ฮ]',
            }}
            permanents={[2, 5]}
            type="text"
            value={sLastNameTH}
            onChange={e =>
              onChange({ key, name: e.target.name, value: e.target.value })
            }
          >
            {inputProps => (
              <input
                id={`sLastNameTH_${key}`}
                {...inputProps}
                className="form-control mt-2"
                placeholder={labelVisa === 1 || labelLang === 2 ? "LAST NAME" : "นามสกุล"}
                name={lastNameKey}
              />
            )}
          </InputMask>
        </div>
        )
    }
}